import styled from 'styled-components';
import { media, breakpoints } from '../breakpoints';

const GUTTER_PX = 24;

const containerStyles = `
  width: 100%;
  padding: 0 clamp(16px, 2.5vw, 80px);
  margin: 0 auto;

  ${media.desktopLarge} {
    max-width: ${breakpoints.desktopLarge}px;
  }
`;

/** Shared page-width wrapper used to keep consistent max-width and breakpoints. */
export const PageContainer = styled.div`
	${containerStyles}
`;

/** Backwards-compatible alias for existing imports. */
export const GridContainer = styled(PageContainer)``;

export const Grid = styled.div`
	display: grid;
	column-gap: ${GUTTER_PX}px;
	row-gap: ${GUTTER_PX}px;
	grid-template-columns: repeat(4, minmax(0, 1fr));

	${media.tablet} {
		grid-template-columns: repeat(8, minmax(0, 1fr));
	}

	${media.desktop} {
		grid-template-columns: repeat(12, minmax(0, 1fr));
	}
`;
